import { SideNavItem } from "src/types/sidenav-item";

export const sideNavItems: SideNavItem[] = [
    {
        name: 'buildings',
        title: 'buildings',
        path: '/buildings',
        icon: '/icons/buildings.svg',
        iconHover: '/icons/buildings-hvr.svg',
    },
    {
        name: 'employees',
        title: 'employees',
        path: '/employees',
        icon: '/icons/users.svg',
        iconHover: '/icons/users-hvr.svg',
    },
    {
        name: 'shop',
        title: 'shop',
        path: '/shop',
        icon: '/icons/shop.svg',
        iconHover: '/icons/shop-hvr.svg',
    },
    {
        name: 'payment',
        title: 'payment',
        path: '/payment/overview',
        icon: '/icons/payment.svg',
        iconHover: '/icons/payment-hvr.svg',
    },
];

export const paymentNavItems: SideNavItem[] = [
    {
        name: 'overview',
        title: 'billing-overview',
        path: '/payment/overview',
    },
    {
        name: 'details',
        title: 'billing-details',
        path: '/payment/details',
    },
    {
        name: 'history',
        title: 'billing-history',
        path: '/payment/history',
    },
];